var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgListDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94682 0.93624C4.52848 0.354587 5.47152 0.354587 6.05317 0.93624L9.56376 4.44682C10.1454 5.02848 10.1454 5.97152 9.56376 6.55317L6.05317 10.0638C5.47152 10.6454 4.52848 10.6454 3.94682 10.0638L0.43624 6.55317C-0.145413 5.97152 -0.145413 5.02848 0.43624 4.44682L3.94682 0.93624Z",
    fill: "#131217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListDot);
export default __webpack_public_path__ + "static/media/listDot.7e973fb75711bf93affc4316b888e725.svg";
export { ForwardRef as ReactComponent };